import createFormSlice from '@/store/reducers/createFormSlice';
import { createSlice } from '@reduxjs/toolkit';
import { simulateSendForm } from '@/core/utils/sendFormData';
import API_ENDPOINTS from '../../api/apiConfig';
import { ForgotPasswordFormTypes } from '@/store/types/forgotPasswordFormTypes';

const forgotPasswordFormData: ForgotPasswordFormTypes = {
	email: '',
};

const formSlice = createFormSlice('forgotPasswordForm', forgotPasswordFormData);

const combinedSlice = createSlice({
	name: 'forgotPasswordForm',
	initialState: formSlice.getInitialState(),
	reducers: {
		...formSlice.caseReducers,
	},
});

export const {
	resetSuccessMessage,
	setError,
} = combinedSlice.actions;

// API ещё не готов — заглушка с полным протоколом slice'а.
// Когда бэкенд сделает эндпоинт: simulateSendForm → sendForm (одно слово),
// контракт — в `src/store/types/forgotPasswordFormTypes.ts`.
export const sendForgotPassword = (data: ForgotPasswordFormTypes) => simulateSendForm(combinedSlice, API_ENDPOINTS.forgotPassword, 'auth.forgot.success_message')(data);

export default combinedSlice.reducer;
export { combinedSlice as forgotPasswordFormSlice };
